/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuestionnaireInitialiseModel } from '../../models/questionnaire-initialise-model';
import { QuestionnaireInstanceModel } from '../../models/questionnaire-instance-model';

export interface QuestionnaireInstancesInitialisePostParams {
      body?: QuestionnaireInitialiseModel
}

export function questionnaireInstancesInitialisePost(http: HttpClient, rootUrl: string, params?: QuestionnaireInstancesInitialisePostParams, headers?: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireInstanceModel>> {
  const rb = new RequestBuilder(rootUrl, questionnaireInstancesInitialisePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  if (headers) {
    for (let headerKey of headers.keys()) {
      rb.header(headerKey, headers.get(headerKey));
    }
  }

  return http.request(
    rb.build({ responseType: 'json', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QuestionnaireInstanceModel>;
    })
  );
}

questionnaireInstancesInitialisePost.PATH = '/api/v1/questionnaire-instances/initialise';
